<template>
    <div
        class="master_nav-item__wrap"
        :data-item-key="info.key"
        :data-level="level"
    >
        <div
            v-if="info.slot"
            tabindex="0"
            role="button"
            @click="onTopClick"
            @keydown.enter.prevent="onTopClick"
            @keydown.space.prevent="onTopClick"
        >
            <slot :name="info.slot" />
        </div>
        <a
            v-else
            class="master_nav-item"
            :class="isTooltipShow ? 'force-hover-state':''"
            :aria-expanded="service.isWide && isExpand?'true':'false'"
            :aria-current="topNeedShowActive ? 'true':'false'"
            flex="-"
            tabindex="0"
            role="button"
            @click="onTopClick"
            @keydown.enter.prevent="onTopClick"
            @keydown.space.prevent="onTopClick"
        >
            <ElTooltip
                ref="mnTooltip"
                v-model="isTooltipShow"
                :transition="service.tooltipTransition"
                :popper-class="`master_nav__tip ${hasChildren ? 'master_nav__tip_lv2': ''}`"
                :offset="hasChildren ? -36 : 0"
                :effect="hasChildren ? 'light' : 'dark'"
                :placement="hasChildren ? 'right-start': 'right'"
                :visible-arrow="false"
                :disabled="service.isWide"
            >
                <div
                    :class="[showLabelUnderIcon ?
                        'master_nav-item__icon-wrap-under-label-mode' :
                        'master_nav-item__icon-wrap']"
                    flex-item=")0("
                    flex="|center"
                >
                    <PtIcon
                        v-if="showNavItemIcon"
                        flex-item="center"
                        :font-size="24"
                        :icon="info.icon"
                    />
                    <Triangle
                        v-if="hasChildren && !service.isWide"
                        class="master_nav-item__triangle"
                    />
                    <div
                        v-if="showLabelUnderIcon"
                        class="master_nav-item__label"
                    >{{ service.$t(info.label || info.key) }}
                    </div>
                </div>
                <template slot="content">
                    <section
                        v-if="hasChildren"
                        style="min-width: 200px"
                        class="master_nav-item__2nd_lv_wrap master_nav-item__2nd_lv_wrap__popover"
                    >
                        <DivLine :label="service.$t(info.label || info.key)" />
                        <a
                            v-for="child in displayChildItems"
                            :key="child.key"
                            class="master_nav-item__2nd_lv"
                            :aria-current="service.currentActiveKey === child.key ? 'true':'false'"
                            :data-level="level"
                            :data-item-key="child.key"
                            tabindex="0"
                            role="button"
                            @click="$emit('onClick', child);service.toggleExpandLv2(child.key, true)"
                            @keydown.enter.prevent="$emit('onClick', child);service.toggleExpandLv2(child.key, true)"
                            @keydown.space.prevent="$emit('onClick', child);service.toggleExpandLv2(child.key, true)"
                        >{{ service.$t(child.label || child.key) }}</a>
                        <slot
                            v-if="isHiddenChild"
                            :name="`${info.key}LimitSlot`"
                            :handler="handleExpandChildren"
                        >
                            <a
                                class="master_nav-item__2nd_lv master_nav-item__more"
                                :class="`${info.key}-nav__more`"
                                data-indent="2"
                                :data-item-key="`${info.key}_key`"
                                tabindex="0"
                                role="button"
                                @click="handleExpandChildren"
                                @keydown.enter.prevent="handleExpandChildren"
                                @keydown.space.prevent="handleExpandChildren"
                            >{{ service.$t(info.limitLabel) || 'more' }}</a>
                        </slot>
                    </section>
                    <!--eslint-disable -->
                    <div
                        v-else
                        v-html="service.$t(info.label || info.key)"
                    />
                </template>
            </ElTooltip>
            <div
                class="master_nav-item__text"
                flex-item="()"
            >
                {{ service.$t(info.label || info.key) }}
            </div>
            <button
                v-if="hasChildren"
                v-show="service.isWide"
                class="master_nav-item__2nd_lv_btn"
                :class="{'master_nav-item__2nd_lv_btn_no_hover': service.onlyLv2Link}"
                flex-item=")0(start"
                type="button"
                @click.stop="$emit('onClickExpand', info.key)"
            >
                <PtIcon :icon="isExpand ? 'SolidArrowSmallUp' : 'SolidArrowsmallDown'" />
            </button>
        </a>
        <section
            v-show="service.isWide && hasChildren && isExpand"
            class="master_nav-item__2nd_lv_wrap master_nav-item__2nd_lv_wrap__default"
        >
            <NavItem
                v-for="child in info.children"
                :key="child.key"
                :info="child"
                :service="service"
                :level="level + 1"
                :data-hidden-item="!displayChildItems.includes(child)"
                @onClickExpand="key => $emit('onClickExpand', key)"
                @onClick="(childInfo) => $emit('onClick', childInfo)"
                @onSlotChange="getSlotName"
                @onChildActive="setActiveStatus"
            >
                <template v-for="(slot) in slots" #[slot]="{ handler }">
                    <slot :name="slot" :handler="handler" />
                </template>
            </NavItem>
            <slot v-if="isHiddenChild" :name="`${info.key}LimitSlot`" :handler="handleExpandChildren">
                <a
                    class="master_nav-item__2nd_lv master_nav-item__more"
                    :class="`${info.key}-nav__more`"
                    :data-level="level + 1"
                    :data-item-key="`${info.key}_more`"
                    tabindex="0"
                    role="button"
                    @click="handleExpandChildren"
                    @keydown.enter.prevent="handleExpandChildren"
                    @keydown.space.prevent="handleExpandChildren"
                >{{ service.$t(info.limitLabel) || 'more' }}</a>
            </slot>
        </section>
    </div>
</template>

<script>
import ElTooltip from 'element-ui/lib/tooltip';
import PtIcon from '@patsnap-biz/icon';
import get from 'lodash/get';
import Triangle from './components/TriangleIcon';
import DivLine from './components/DivLine';

export default {
    name: 'NavItem',
    components: {
        Triangle,
        DivLine,
        ElTooltip,
        PtIcon,
    },
    props: {
        service: { type: Object, required: true },
        info: {
            type: Object,
            required: true,
        },
        level: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            isTooltipShow: false,
            slots: [],
            isShowAllChild: false,
        };
    },
    computed: {
        isChildActive() {
            return this.service.getIsChildActive(this.info.key, [this.info]);
        },
        // 窄模式时，父需要显示是否子Active
        topNeedShowActive() {
            if (this.service.currentActiveKey === this.info.key) {
                return true;
            }
            // 窄模式时只有层级1的父级需要显示active样式
            if ((!this.service.isWide) && this.isChildActive && this.level === 1) {
                return true;
            }
            return false;
        },
        isExpand() {
            return this.service.isExpanded(this.info.key);
        },
        hasChildren() {
            return this.info.children && this.info.children.length;
        },
        showLabelUnderIcon() {
            return this.service.showLabelUnderIcon && !this.service.isWide;
        },
        isHiddenChild() {
            return this.hasChildren
                && this.info.childLimit !== undefined
                && !this.info.showAllChild
                && !this.isShowAllChild;
        },
        displayChildItems() {
            return this.isHiddenChild
                ? (this.info.children || []).slice(0, this.info.childLimit)
                : this.info.children;
        },
        hiddenChildKeys() {
            const hiddenChild = this.info.children.slice(this.info.childLimit) || [];
            return hiddenChild.map((item) => item.key);
        },

        // 临时性的兼容逻辑，只显示第一层级的icon
        showNavItemIcon() {
            return this.level === 1;
        },
    },
    watch: {
        isTooltipShow() {
            this.service.openTipLv2Hook(this.isTooltipShow);
        },
        // 动态修改navs时，需要监听变动动态抛出插槽
        'info.slot': {
            handler(val) {
                if (val) {
                    this.$emit('onSlotChange', [this.info.slot]);
                }
            },
            immediate: true,
        },
        'service.currentActiveKey': {
            handler() {
                this.checkActiveKey(this.service.currentActiveKey);
            },
            immediate: true,
        },
        isHiddenChild: {
            handler(val) {
                if (val) {
                    this.$emit('onSlotChange', [`${this.info.key}LimitSlot`]);
                }
            },
            immediate: true,
        },
        isChildActive: {
            handler(val) {
                if (val) {
                    this.service.setExpandedKey(this.info.key);
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.useFastClose();
    },
    methods: {
        useFastClose() { // 普通hover离开时快速关闭
            if (!get(this, '$refs.mnTooltip.handleClosePopper') || !get(this, '$refs.mnTooltip.debounceClose')) {
                return;
            }
            const debClose = this.$refs.mnTooltip.debounceClose.bind(this.$refs.mnTooltip);
            this.$refs.mnTooltip.debounceClose = (...args) => {
                if (this.hasChildren) {
                    debClose(...args);
                } else {
                    this.$refs.mnTooltip.handleClosePopper(...args);
                }
            };
        },
        onTopClick() {
            if (this.hasChildren && this.service.onlyLv2Link) {
                this.$emit('onClickExpand', this.info.key);
            } else {
                this.$emit('onClick', this.info);
            }
        },
        getSlotName(slots) {
            this.slots.push(...slots);
            this.$emit('onSlotChange', this.slots);
        },
        handleExpandChildren() {
            this.isShowAllChild = true;
            this.service.onClickedMoreHook(this.info.key, this.info);
        },
        checkActiveKey(key) {
            if (this.isHiddenChild && this.hiddenChildKeys.includes(key)) {
                this.isShowAllChild = true;
            }
        },
        setActiveStatus() {
            this.isShowAllChild = true;
            this.$emit('onChildActive');
        },
    },
};
</script>
